export default __webpack_public_path__ + "static/media/phone.0b1c25f7.svg";